<template lang="html">
  <div class="model-nav-button"
       :class="{'model-nav-button--active': active}"
       @mousedown="isMouseDown = true"
       @mouseup="isMouseDown = false"
       @mouseout="isMouseDown = false"
       @click="$emit('click')">
    <img :src="image" class="model-nav-button__image">
    <div class="model-nav-button__label">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModelNavButton',
  props: {
    idle: {
      type: String,
      default: ''
    },
    pressed: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isMouseDown: false
    };
  },
  computed: {
    image() {
      if (this.isMouseDown || this.active) return this.pressed;
      return this.idle;
    }
  }
};
</script>

<style lang="scss" scoped>
.model-nav-button {
  width: 129px;
  height: 78px;
  border-bottom: 2px solid #b1dbf9;
  background-color: #ddeffb;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: .15s;

  &:hover {
    background-color: #cae8fb;
    cursor: pointer;
  }

  &--active {
    background-color: #cae8fb;
    cursor: default;
  }

  &__image {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  &__label {
    color: #75899a;
    font-size: 16px;
    margin-top: 10px;
    user-select: none;
  }
}
</style>
